import React, { useState, useEffect } from 'react';
import { getAvailableConfigs } from '../services/api';
import ConfigViewer from '../components/ConfigViewer';

const ConfigPage = () => {
  const [availableConfigs, setAvailableConfigs] = useState([]);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        setLoading(true);
        const result = await getAvailableConfigs();
        
        if (result.configs && result.configs.length > 0) {
          setAvailableConfigs(result.configs);
          // Default to the first config
          setSelectedConfig(result.configs[0].id);
        }
        
        setLoading(false);
      } catch (error) {
        setError('Error loading configurations');
        setLoading(false);
      }
    };

    fetchConfigs();
  }, []);

  if (loading) {
    return <div>Loading configurations...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="config-page">
      <div className="page-header">
        <h1>Available Configurations</h1>
        <p>View the different configurations used for EWS analysis</p>
      </div>

      <div className="config-list">
        {availableConfigs.map(config => (
          <div 
            key={config.id} 
            className={`config-card ${selectedConfig === config.id ? 'selected' : ''}`}
            onClick={() => setSelectedConfig(config.id)}
          >
            <h3>{config.name}</h3>
            <p>ID: {config.id}</p>
            <p>Alternative ID: {config.alternative_id}</p>
            <button onClick={() => setSelectedConfig(config.id)}>
              View Details
            </button>
          </div>
        ))}

        {availableConfigs.length === 0 && (
          <div className="no-configs">
            <p>No configurations available</p>
          </div>
        )}
      </div>

      {selectedConfig && (
        <ConfigViewer configName={selectedConfig} />
      )}
    </div>
  );
};

export default ConfigPage;
